// extracted by mini-css-extract-plugin
module.exports = {"propertyBlock":"PropertyStarter-module--propertyBlock--34Qkk","property":"PropertyStarter-module--property--339L8"};